import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/italic.tsx
var Italic = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M9.58203 3H19.0002",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M5 21H14.4182",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M14.2962 3L9.71436 21",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.83203 3C8.83203 2.58579 9.16782 2.25 9.58203 2.25H19.0002C19.4144 2.25 19.7502 2.58579 19.7502 3C19.7502 3.41421 19.4144 3.75 19.0002 3.75H9.58203C9.16782 3.75 8.83203 3.41421 8.83203 3Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.25 21C4.25 20.5858 4.58579 20.25 5 20.25H14.4182C14.8324 20.25 15.1682 20.5858 15.1682 21C15.1682 21.4142 14.8324 21.75 14.4182 21.75H5C4.58579 21.75 4.25 21.4142 4.25 21Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.4809 2.27323C14.8823 2.37541 15.1249 2.78365 15.0227 3.18507L10.4409 21.1851C10.3387 21.5865 9.93045 21.8291 9.52904 21.7269C9.12762 21.6247 8.88505 21.2165 8.98722 20.815L13.569 2.81505C13.6712 2.41364 14.0795 2.17106 14.4809 2.27323Z",
			fill: "currentColor"
		})
	] })
});
//#endregion
export { Italic };
